import { notification } from "antd";
import { merge } from "lodash-es";
import { locale } from "../data/locale";

export const API_ROOT = process.env.REACT_APP_API_URL as string;
if (!API_ROOT) {
  throw new Error("REACT_APP_API_URL env variable is missing!");
}

export enum keys {
  "public" = "satc_public",
  "cont" = "satc_contracting",
  "equip" = "satc_equipments"
}

export async function appFetch<T>(
  path: string,
  config?: RequestInit
): Promise<T> {
  const fullPath = path.indexOf(API_ROOT) === -1 ? API_ROOT + path : path;
  const res = await fetch(
    fullPath,
    // add base headers to config
    merge(
      {
        headers: {
          Accept: "application/json",
          "Accept-Language": locale === "en" ? "en" : "ar",
          "WEBSITE-KEY": keys.cont, // default website key (required by api)
        },
      },
      config
    )
  );
  const data = await res.json();

  // handle errors
  if (!res.ok) {
    if (typeof data.errors === "object") {
      Object.values(data.errors).forEach((err) => {
        notification.error({
          message: err as string,
          className: "no-desc-notification",
        });
      });
    } else
      notification.error({
        message: data.message,
        className: "no-body-notification",
      });
    throw data;
  }

  return data;
}

export interface APIData<T> {
  data: T;
  [key: string]: any; // allow other data
}
